import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { isString as _isString } from 'lodash';
import { Observable } from 'rxjs';

import * as appStateActions from '../../+state/app-state/app-state.actions';
import * as geoCoderActions from '../../+state/geo-coder/geo-coder.actions';
import { FullAddressDetails, Prediction } from '../../+state/geo-coder/geo-coder.models';
import { State } from '../../+state/selectors';
import * as fromRoot from '../../+state/selectors';
import * as ServiceLocatorActions from '../../+state/service-locator/service-locator.actions';
import { SearchedValue } from '../../+state/service-locator/service-locator.models';

@Component({
  selector: 'drp-search-wrapper',
  templateUrl: './search-wrapper.component.html',
  styleUrls: ['./search-wrapper.component.scss'],
  standalone: false
})
export class SearchWrapperComponent implements OnInit {
  searchShopBy$: Observable<string>;
  predicting$: Observable<boolean>;
  predictions$: Observable<Prediction[]>;
  addressToPopulate$: Observable<FullAddressDetails>;
  appState$: Observable<string>;
  mapTriggerState$: Observable<string>;
  inputSearchValue$: Observable<SearchedValue>;

  constructor(private store: Store<State>) {}

  ngOnInit() {
    this.predicting$ = this.store.select(fromRoot.getGeoApiLoading);
    this.searchShopBy$ = this.store.select(fromRoot.getSearchType);
    this.predictions$ = this.store.select(fromRoot.getPredictions);
    this.addressToPopulate$ = this.store.select(fromRoot.getFullAddress);
    this.appState$ = this.store.select(fromRoot.getCurrentAppState);
    this.mapTriggerState$ = this.store.select(fromRoot.getMapRedrawTriggerState);
    this.inputSearchValue$ = this.store.select(fromRoot.getSearchedValue);
  }

  /**
   * Initiate the drp-locator search using the given value
   * Set the map redraw trigger state to on-search
   * @param searchedValue name/location value to search
   */
  setSearchedValue(searchedValue: SearchedValue) {
    this.store.dispatch(new ServiceLocatorActions.ServiceSearchAction(searchedValue));
  }

  /**
   * Set the value of what type of search is being conducted
   * name, location or autocomplete
   * @param type name, location, or autocomplete
   */
  changeSearchBy(type: string) {
    this.store.dispatch(new appStateActions.SetSearchTypeAction(type));
  }

  /**
   * Handle autocomplete events requested by form components by firing action with the search string
   *
   * resultTypes: geocode || establishment
   */
  onRequestAutocompleteEvent(input: string, resultTypes: string) {
    this.store.dispatch(
      new geoCoderActions.GetAutocompleteResultsAction({
        types: resultTypes,
        input: input
      })
    );
  }

  /** Get the address associated with the given place_id
   * @param place
   */
  getAddressToPopulateForm(place) {
    this.store.dispatch(new geoCoderActions.GetSelectedAddressDetailsAction(place.place_id));
  }
}
